import { trackStructEvent } from "@snowplow/browser-tracker";

import {
  ONEPASS_ACTION_UPSELL_RESULT,
  ONEPASS_CATEGORY,
  ONEPASS_NOTIFICATION_LABEL_ERROR,
  ONEPASS_NOTIFICATION_LABEL_SUCCESS,
} from "@analytics/consts";
import { OnePassNotificationType } from "@analytics/types";

type EmitUpsellNotificationParams = {
  type: OnePassNotificationType;
  message: string;
};

export function emitUpsellNotification({
  type,
  message,
}: EmitUpsellNotificationParams) {
  trackStructEvent({
    category: ONEPASS_CATEGORY,
    action: ONEPASS_ACTION_UPSELL_RESULT,
    label:
      type === "success"
        ? ONEPASS_NOTIFICATION_LABEL_SUCCESS
        : ONEPASS_NOTIFICATION_LABEL_ERROR,
    property: message,
  });
}
